import { render } from "./control-sidebar.html?vue&type=template&id=51735720&ts=true"
import script from "./control-sidebar.ts?vue&type=script&lang=ts"
export * from "./control-sidebar.ts?vue&type=script&lang=ts"

import "./control-sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__